export enum ScenariosPermission {
  OWNER = 'OWNER',
  EDIT = 'EDIT',
  READ_ONLY = 'READ_ONLY',
}
